import { CONSTANTS } from '@/common/constants.js';

const cellErrorHighlightMixin = {
	computed: {
		/**
		 * Gets the field highlight style if there is an error or trend error.
		 */
		highlightStyle: function () {
      let highlightType = this.$store.getters['validation/highlightType'](this.qId, this.ctrlId);
      if (highlightType === CONSTANTS.VALIDATION_SEVERITY_TYPE.ERROR) {
        return 'highlightError';
			} else if (highlightType === CONSTANTS.VALIDATION_SEVERITY_TYPE.WARNING) {
				return 'highlightTrend';
			}
      return '';
		}
	}
};

export default cellErrorHighlightMixin;
